module.exports = __webpack_public_path__ + "img/pending.edb6cda1.png";